var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { radioClasses } from '@mui/material/Radio';
export var createMuiRadioOverrides = function (_a) {
    var _b;
    var palette = _a.palette, tokens = _a.tokens, transitions = _a.transitions, mixins = _a.mixins, typography = _a.typography;
    return {
        defaultProps: {
            color: 'primary',
        },
        styleOverrides: {
            root: {
                padding: 0,
                transition: transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
                    duration: transitions.duration.short,
                }),
                color: tokens.color_border_input,
                '&:focus-within svg': __assign({ borderRadius: '50%' }, mixins.focusRing()),
                // switch base is overriding this. Resetting it here.
                '&&': {
                    padding: 0,
                    height: typography.pxToRem(18),
                    width: typography.pxToRem(18),
                },
            },
            colorPrimary: (_b = {
                    '&:hover,': {
                        backgroundColor: 'transparent',
                    }
                },
                _b["&.".concat(radioClasses.disabled)] = {
                    backgroundColor: 'transparent',
                },
                _b["&:hover:not(.".concat(radioClasses.checked, ")")] = {
                    color: tokens.color_border_input_hover,
                    '& svg :last-child': {
                        fill: palette.action.hoverBackground,
                    },
                },
                _b["&.".concat(radioClasses.checked)] = {
                    color: tokens.color_bg_selected,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
                _b["&.".concat(radioClasses.checked, ".").concat(radioClasses.disabled)] = {
                    color: tokens.color_bg_input_disabled_bold,
                },
                _b["&.".concat(radioClasses.disabled, ":not(.").concat(radioClasses.checked, ")")] = {
                    color: tokens.color_border_input_disabled,
                    '& svg :last-child': {
                        fill: tokens.color_bg_input_disabled,
                    },
                },
                _b),
        },
    };
};
